import React from "react";
import Typography from "../../../../Typography";
import { jsxs as _jsxs } from "react/jsx-runtime";
function NoOptionsMessage(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/_jsxs(Typography, {
    variant: "display300",
    children: ["Selected time: ", value]
  });
}
export default NoOptionsMessage;